import Changeset from 'ember-changeset';
import Component from '@ember/component';
import PikadayInput from 'donor-elf-web/components/pikaday-input';
import Settings from 'donor-elf-web/services/settings';
import { concat, hash } from '@ember/helper';
import { get } from '@ember/object';
import { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import lifecycle from 'donor-elf-web/modifiers/lifecycle';

interface ComponentArgs {
  changeset: Changeset;
  property: string;
  label?: string;
  labelIsHtmlSafe?: boolean;
  disabled?: boolean;
  showValidationErrors?: boolean;
  onSelected?: (date: Date) => void;
  onOpened?: () => void;
}

export default class FormGroupDateComponent extends Component<ComponentArgs> {
  @service declare settings: Settings;

  @tracked changeset?: Changeset;
  @tracked property = '';
  @tracked label = '';
  @tracked labelIsHtmlSafe = false;
  @tracked disabled = false;
  @tracked showValidationErrors = false;
  @tracked pikadayContainer?: any;

  get hasErrors() {
    if (this.showValidationErrors === false) {
      return false;
    }

    let property = this.property;
    return (
      this.changeset?.errors.find(function (item) {
        return item.key === property;
      }) != null
    );
  }

  handleSelected = (date) => {
    this.changeset?.set(this.property, date);
    this.onSelected?.(date);
  }

  handleOpened = () => {
    this.onOpened?.();
  }

  handlePikadayContainerLifecycle = (el:any) => {
    this.pikadayContainer = el;
  }

  <template>
    {{#if this.label}}
      {{#if this.labelIsHtmlSafe}}
        <label>{{{this.label}}}</label>
      {{else}}
        <label>{{this.label}}</label>
      {{/if}}
    {{/if}}
    {{#if this.pikadayContainer}}
      <PikadayInput
        @value={{(get this.changeset this.property)}}
        @format={{this.settings.dateFormat4Year}}
        @firstDay={{0}}
        @disabled={{this.disabled}}
        @onOpen={{this.handleOpened}}
        @onSelection={{this.handleSelected}}
        @container={{this.pikadayContainer}}
        class='form-control'
      />
    {{/if}}
    <div {{lifecycle this.handlePikadayContainerLifecycle}}></div>
    {{#if this.hasErrors}}
      <div class='has-errors-message'>{{get
          this.changeset.error
          (concat this.property '.validation')
        }}</div>
    {{/if}}
  </template>
}
